<ng-container *ngFor="let app of applications">
  <app-doctors-station
    *ngIf="isStation && app.clientId === clientId"
    [clientId]="clientId"
  ></app-doctors-station>
  <app-dr-dish
    *ngIf="app.type === 'dr-dish' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-dr-dish>
  <app-suguyaku
    *ngIf="app.type === 'suguyaku' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-suguyaku>
  <app-doctors-next
    *ngIf="app.type === 'dnext' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-doctors-next>
  <app-collabo-portal
    *ngIf="app.type === 'cportal' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-collabo-portal>
  <app-sgzp-app2
    *ngIf="app.type === 'cportal-sgzp-app2' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-sgzp-app2>
  <app-sas-station
    *ngIf="app.type === 'sas-station' && app.clientId === clientId"
    [clientId]="clientId"
  ></app-sas-station>
</ng-container>
<app-dynamic-component-host #dynamicComponentHost></app-dynamic-component-host>
